module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/icon-pro.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/icon-pro.png
// module id = 1213
// module chunks = 0